import { createI18n } from 'vue-i18n';
function loadLocaleMessages() {
    // @ts-ignore
    const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.(json|ts|js)$/i);
    const messages = {};
    locales.keys().forEach((key) => {
        const path = key.replace(/\.\/|\.(json|ts|js)$/g, '').split('/');
        path.reduce((msg, ele, idx, src) => {
            if (!msg[ele]) {
                let value = locales(key);
                // js, ts의 경우 export default로 노출하고 이곳에서 추출한다.
                if ('default' in value) {
                    value = value.default;
                }
                Object.assign(msg, {
                    [ele]: idx + 1 < src.length ? {} : value,
                });
            }
            return msg[ele];
        }, messages);
    });
    return messages;
}
const brgI18n = createI18n({
    legacy: false,
    locale: 'ko',
    fallbackLocale: 'ko',
    globalInjection: true,
    messages: loadLocaleMessages(),
    silentTranslationWarn: true,
});
export const setLocalePath = (filePath) => (key, param) => brgI18n.global.t(`${filePath}${key}`, param);
export default brgI18n;
export const i18n = brgI18n.global;
